// extracted by mini-css-extract-plugin
export default {"titlePageHolder":"TitlePage_titlePageHolder__qMMUy","titles":"TitlePage_titles__QZuBT","backArrow":"TitlePage_backArrow__Q8JEu"};